import { useTranslations } from "@jugl-web/utils";
import tileGif from "./assets/tile.gif";

export const CTABanner = ({ name }: { name: string }) => {
  const { t } = useTranslations();
  const nameString = `${name} ${t({
    id: "board-templates-drawer.cta-banner-made-easy",
    defaultMessage: "Made Easy",
  })} ✨`;
  return (
    <div
      className="flex items-center justify-between rounded-2xl p-6 font-secondary"
      style={{
        background:
          "linear-gradient(90deg,rgba(251, 238, 255, 1) 66%, rgba(227, 242, 254, 1) 100%)",
      }}
    >
      <div className="flex w-full flex-col">
        <div
          className="w-full max-w-[80%] truncate text-[22px] font-medium"
          title={nameString}
        >
          {nameString}
        </div>
        <div className="w-[420px] pt-[10px] text-sm text-[#828282]">
          {t({
            id: "board-templates-drawer.cta-banner-description",
            defaultMessage:
              "Don’t start from scratch - jump ahead with a ready made template that does the hard work for you.",
          })}
        </div>
        {/* <div className="pt-[32px]">
          <Button
            iconEnd={<ArrowIcon />}
            className="h-[40px] w-[190px] font-medium"
            size="small"
            onClick={() => handleUseTemplate(name)}
          >
            {t({
              id: "board-templates-drawer.use-template-button",
              defaultMessage: "Use Template",
            })}
          </Button> 
        </div> */}
      </div>
      <img src={tileGif} alt="tile gif" className="h-auto w-[150px]" />
    </div>
  );
};
